import request from '@/utils/request'

// 添加留言
export function addMessage (data) {
  return request.post('/message/add', data)
}

// 获取留言列表
export function getMessages (params) {
  return request.get('/message/list', { params })
}

// 点赞
export function likeMessage (id) {
  return request.post('/message/like', { id })
}

// 取消点赞
export function unlikeMessage (id) {
  return request.post('/message/unlike', { id })
}

// 添加评论
export function addComment (data) {
  // data: { messageId, content }
  return request.post('/message/comment', data)
}
